import { useEffect, useState } from "react";
import { Feather } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const BrandMark = ({ size = 36, iconSize = 16, className = "" }) => {
  const settings = useSettings();
  const logoSrc = settings.logo_url ? `${process.env.REACT_APP_BACKEND_URL}${settings.logo_url}` : null;
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    if (!logoSrc) return;
    const img = new Image();
    img.onload = () => setReady(true);
    img.src = logoSrc;
  }, [logoSrc]);

  if (logoSrc && ready) {
    return (
      <img
        src={logoSrc}
        alt={settings.company_name}
        style={{ height: size }}
        className={`w-auto object-contain bg-white rounded-lg px-2 py-1 ${className}`}
      />
    );
  }
  return (
    <span
      className={`rounded-full border border-gold/40 flex items-center justify-center text-gold ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-mark-fallback"
    >
      <Feather size={iconSize} strokeWidth={1.75} />
    </span>
  );
};

export const BrandName = ({ className = "" }) => {
  const settings = useSettings();
  const parts = settings.company_name.split(" ");
  return (
    <span className={className}>
      {parts[0]} <span className="italic text-gold">{parts.slice(1).join(" ")}</span>
    </span>
  );
};
